import { render, staticRenderFns } from "./IncidentReportContent.vue?vue&type=template&id=74843faf&"
import script from "./IncidentReportContent.vue?vue&type=script&lang=js&"
export * from "./IncidentReportContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports